import { defineMessages } from '@jutro/locale';

export default defineMessages({
    /* ---------- Section Header ---------- */
    homeInspectionHeader: {
        id: 'ml.quoteandbind.ho.additionalinfoprebind.homeInspectionHeader',
        defaultMessage: 'Home Inspection'
    },

    /* ---------- Inline Inspection Message ---------- */
    inspectionPrefix: {
        id: 'ml.quoteandbind.ho.inspection.type.homeInspectionAn',
        defaultMessage: 'An '
    },
    inspectionExteriorOnly: {
        id: 'ml.quoteandbind.ho.inspection.type.exterioronly',
        defaultMessage: 'Exterior Only'
    },
    inspectionMidValue: {
        id: 'ml.quoteandbind.ho.inspection.type.midvalue',
        defaultMessage: 'Mid-Value / Modified High Value'
    },
    inspectionHighValue: {
        id: 'ml.quoteandbind.ho.inspection.type.highvalue',
        defaultMessage: 'High Value'
    },
    inspectionSuffix: {
        id: 'ml.quoteandbind.ho.inspection.type.homeInspectionrequiredP',
        defaultMessage: ' inspection will be required for this policy.'
    },

    /* ---------- No Inspection ---------- */
    noInspectionRequired: {
        id: 'ml.quoteandbind.ho.inspection.none',
        defaultMessage: 'No inspection will be required for this policy.'
    },

    /* ---------- Modal : Common ---------- */
    inspectionModalTitle: {
        id: 'ml.quoteandbind.ho.inspection.modal.title',
        defaultMessage: 'Inspection Key Reminders'
    },

    /* ---------- Modal : Exterior Only ---------- */
    inspectionModalIntroExteriorOnly: {
        id: 'ml.quoteandbind.ho.inspection.modal.intro.exterioronly',
        defaultMessage: 'An Exterior Only inspection may be completed on-site by a professional or by the customer completing a self-survey.'
    },

    /* ---------- Exterior Only – On-site ---------- */
    exteriorOnsiteHeader: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.header',
        defaultMessage: 'Exterior Only - On-site'
    },
    exteriorOnsiteItem1: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item1',
        defaultMessage: 'The inspection helps us to review and confirm information about the property.'
    },
    exteriorOnsiteItem2: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item2',
        defaultMessage: 'The inspection process begins after the policy is effective.'
    },
    exteriorOnsiteItem3: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item3',
        defaultMessage: 'It may take 30 days to complete.'
    },
    exteriorOnsiteItem4: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item4',
        defaultMessage: 'An inspection does not require an appointment.'
    },
    exteriorOnsiteItem5: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item5',
        defaultMessage: 'The customer does not need to be home.'
    },
    exteriorOnsiteItem6: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item6',
        defaultMessage: 'Inspectors are not required to call ahead.'
    },
    exteriorOnsiteItem7: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item7',
        defaultMessage: 'If the inspector is having difficulty locating the property while en route, they may contact the customer for directions. Please ensure the customer phone number in the policy system is the best contact number.'
    },
    exteriorOnsiteItem8: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorOnsite.item8',
        defaultMessage: "Please confirm the customer's email address in the policy system is correct; the inspection process will be outlined in an email."
    },

    /* ---------- Exterior Only – Self-Survey ---------- */
    exteriorSelfSurveyHeader: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.header',
        defaultMessage: 'Exterior Only - Self-Survey'
    },
    exteriorSelfSurveyItem1: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item1',
        defaultMessage: 'The inspection helps us to review and confirm information about the property.'
    },
    exteriorSelfSurveyItem2: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item2',
        defaultMessage: 'This option allows customers to take property photos based on their schedule and avoids an unknown person at the property, which can make some insureds uncomfortable.'
    },
    exteriorSelfSurveyItem3: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item3',
        defaultMessage: 'For text messages, confirm the phone type in the policy system is a cell phone.'
    },
    exteriorSelfSurveyItem4: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item4',
        defaultMessage: "Please confirm the customer's email address in the policy system is correct; a link to begin will be sent to that email address."
    },
    exteriorSelfSurveyItem5: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item5',
        defaultMessage: 'The customer will be sent a link to take photos after the policy effective date.'
    },
    exteriorSelfSurveyItem6: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item6',
        defaultMessage: 'The customer will have 14 days to take photos.'
    },
    exteriorSelfSurveyItem7: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item7',
        defaultMessage: 'Completion of the self-survey requires a smart phone or tablet and internet connection.'
    },
    exteriorSelfSurveyItem8: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item8',
        defaultMessage: 'The customer may forward the survey link to a trusted person to take the photos.'
    },
    
    exteriorSelfSurveyItem9: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item9',
        defaultMessage: 'If the survey is not complete by day 15, the order will automatically move to an on-site, vendor-conducted inspection.'
    },
    exteriorSelfSurveyItem10: {
        id: 'ml.quoteandbind.ho.inspection.modal.exteriorSelfSurvey.item10',
        defaultMessage: 'The photos will be reviewed by a third party before the results are returned to Underwriting.'
    },

    /* ---------- Mid-Value / Modified High Value ---------- */
    midValueHeader: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.header',
        defaultMessage: 'Mid-Value / Modified High Value'
    },
    midValueItem1: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item1',
        defaultMessage: 'The inspection helps us to review and confirm information about the property.'
    },
    midValueItem2: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item2',
        defaultMessage: 'The Inspection process begins after the policy is effective.'
    },
    midValueItem3: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item3',
        defaultMessage: 'It may take 30 days to complete.'
    },
    midValueItem4: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item4',
        defaultMessage: 'An inspector will call to arrange an onsite, interior and exterior inspection.'
    },
    midValueItem5: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item5',
        defaultMessage: "If the customer doesn't promptly schedule the appointment when contacted, the inspection will be returned to Underwriting as incomplete."
    },
    midValueItem6: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item6',
        defaultMessage: 'Please ensure the customer phone number in the policy system is the best contact number.'
    },
    midValueItem7: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item7',
        defaultMessage: "If a customer doesn't promptly complete the phone interview, the inspection will be returned to Underwriting as incomplete."
    },
    midValueItem8: {
        id: 'ml.quoteandbind.ho.inspection.modal.midvalue.item8',
        defaultMessage: 'Please confirm the customer email address in the policy system is correct; the inspection process will be outlined via email.'
    },

    /* ---------- High Value ---------- */
    highValueHeader: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.header',
        defaultMessage: 'High Value'
    },
    highValueItem1: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.item1',
        defaultMessage: 'The inspection helps us to review and confirm information about the property.'
    },
    highValueItem2: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.item2',
        defaultMessage: 'The inspection process begins after the policy is effective.'
    },
    highValueItem3: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.item3',
        defaultMessage: 'It may take 30 days to complete.'
    },
    highValueItem4: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.item4',
        defaultMessage: 'An inspector will call to arrange an onsite, interior and exterior inspection.'
    },
    highValueItem5: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.item5',
        defaultMessage: "If the customer doesn't promptly schedule the appointment when contacted, the inspection will be returned to Underwriting as incomplete."
    },
    highValueItem6: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.item6',
        defaultMessage: 'Please ensure the customer phone number in the policy system is the best contact number.'
    },
    highValueItem7: {
        id: 'ml.quoteandbind.ho.inspection.modal.highvalue.item7',
        defaultMessage: 'Please confirm the customer email address in the policy system is correct; the inspection process will be outlined via email.'
    },
    
    inspectionClose: {
        id: 'ml.quoteandbind.ho.inspection.modal.close',
        defaultMessage: 'CLOSE'
    }
});
